import { ErrorState } from "$components/error-state";
import { FormattedMessage } from "react-intl";

export const DbErrorPage: FC<{
  isPatientPage?: boolean;
  isRecoverable: boolean;
}> = ({ isPatientPage, isRecoverable }) => (
  <ErrorState
    title={
      isPatientPage ? (
        <FormattedMessage
          id="dbErrorPage.patient.title"
          defaultMessage="Patient data unavailable"
        />
      ) : (
        <FormattedMessage
          id="dbErrorPage.generic.title"
          defaultMessage="This page is unavailable"
        />
      )
    }
    body={
      isPatientPage ? (
        isRecoverable ? (
          <FormattedMessage
            id="dbErrorPage.patient.recoverableBody"
            defaultMessage="An error occurred while loading this patient. Refresh the page to try again."
          />
        ) : (
          <FormattedMessage
            id="dbErrorPage.patient.fatalBody"
            defaultMessage="An error occurred while loading this patient. Contact Elephant to report the issue."
          />
        )
      ) : isRecoverable ? (
        <FormattedMessage
          id="dbErrorPage.generic.recoverableBody"
          defaultMessage="An error occurred while loading the page. Refresh to try again."
        />
      ) : (
        <FormattedMessage
          id="dbErrorPage.generic.fatalBody"
          defaultMessage="An error occurred while loading the page. Contact Elephant to report the issue."
        />
      )
    }
    showRetry={isRecoverable}
  />
);
